import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const bottleTypeApi = {
  getAll: () => axiosClient.get(ENDPOINTS.bottleTypes.list).then(unwrap),
  create: (typeName) => axiosClient.post(ENDPOINTS.bottleTypes.create, { typeName }).then(unwrap),
  update: (id, typeName) => axiosClient.put(ENDPOINTS.bottleTypes.update(id), { typeName }).then(unwrap),
  setStatus: (id, status) =>
    axiosClient.patch(ENDPOINTS.bottleTypes.status(id), null, { params: { status } }).then(unwrap),
  remove: (id) => axiosClient.delete(ENDPOINTS.bottleTypes.delete(id)).then(unwrap),
};
